import React from 'react';
import DocumentTitle from 'react-document-title';
import * as Connections from "../../utils/Connections.js";
import TextField from '@material-ui/core/TextField';
import AutoComplete from 'material-ui/AutoComplete';
import {MuiPickersUtilsProvider, DatePicker} from 'material-ui-pickers';
import DateFnsUtils from '@date-io/date-fns';
import {isDashboard} from "../../utils/Connections";
import {
    getCabbageProgram,
    getCitrusNutritional,
    getCitrusProgram,
    getMacadenianSprayingProgram, getMacaNutritional,
    getSpinachNutritional,
    getSpinachSprayingProgram, getTomatoProgram
} from "../../utils/Constants";

const styles = {
    modal: {
        borderRadius: '0'
    },
    marginSide: {
        marginLeft: '1em'
    },
    date: {
        marginTop: "0px !important"
    }
};

let leftUnits = ["Kg", "Liters", "ml", "grams", "drops"]
let rightUnits = ["ha", "100l", "tree"]
let aplicationUnits = ["ha", "tree"]
let products = ["Spinach", "Citrus", "Macadamia","Cabbage","Tomato"]
let category = ["Crop Protection", "Crop Nutrition"]

class AddSprayingProgram extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            datasource: [],
            searchText: "",
            rawData: [],
            amount: "",
            phi: "",
            dilution: "",
            bugs: "",
            application: "",
            ingredient: "",
            comments: "",
            farmer: props.location.state.farmerProfile,
            suggestions: getSpinachSprayingProgram(),
            standardProgramProtection: {
                Spinach: getSpinachSprayingProgram(),
                Macadamia: getMacadenianSprayingProgram(),
                Citrus: getCitrusProgram(),
                Cabbage: getCabbageProgram(),
                Tomato: getTomatoProgram()
            },
            standardProgramNutritional: {
                Spinach: getSpinachNutritional(),
                Macadamia: getMacaNutritional(),
                Citrus: getCitrusNutritional(),
                Cabbage: getCabbageProgram(),
                Tomato: getTomatoProgram()
            },
            updatedDate: "",
            leftUnit: leftUnits[0],
            rightUnit: rightUnits[0],
            measure: rightUnits[0],
            product: products[0],
            category: category[0]
        }
        this.handleRemove = this.handleRemove.bind(this)

    }

    successAddedSprayingProgram = (data) => {
        // console.log(data)
        alert(data)
    }
    uploadSuggestion = () => {
        const data = {
            "type": "uploadSuggestions",
            "suggestions": JSON.stringify(this.state.suggestions),
            "farmerId": this.props.location.state.farmerProfile.id,
            "product": this.state.product,
            "category": this.state.category
        }
        Connections.performSecureRequest(data, this.successAddedSprayingProgram, this.error)
    }
    successProducts = (data) => {
        let rawInfo = [];
        data.forEach(function (item) {
            rawInfo.push(item.name.toLowerCase())
        })
        this.setState({
            rawData: data,
            datasource: rawInfo,
            selectedDate: "",
            updatedDate: ""
        })
    }
    error = (error) => {

    }
    addToSuggestedList = () => {
        let suggestion = {
            selectedDate: this.state.selectedDate,
            selectedProduct: this.state.selectedProduct,
            quantity: this.state.amount,
            PHI: this.state.phi,
            rate: this.state.amount + this.state.leftUnit + "/" + this.state.rightUnit,
            application: this.state.application + "/" + this.state.measure,
            bugs: this.state.bugs,
            ingredient: this.state.ingredient,
            comment: this.state.comments
        }
        let list = this.state.suggestions
        list.push(suggestion)
        this.setState({
            suggestions: list,
            quantity: "",
            PHI: "",
            unitSize: "",
            comments: ""
        })
    }

    componentDidMount() {
        const data = {
            "type": "getProductsList",
        }
        Connections.performSecureRequest(data, this.successProducts, this.error)
    }

    handleDateChange = date => {
        this.setState({
            selectedDate: date.target.value,
            updatedDate: date.target.value
        });
    };

    handleUpdateInput = (searchText) => {
        this.setState({
            searchText: searchText.toLowerCase(),
        });
    };

    handleRemove(item) {
        let suggestions = this.state.suggestions.filter(function (innerItem) {
            return item !== innerItem
        });
        this.setState({
            suggestions: suggestions
        })
    }

    handleNewRequest = (selectedText) => {
        let selectedProduct = this.state.rawData.find(function (item) {
            return item.name.toLowerCase().includes(selectedText)
        })
        this.setState({
            selectedProduct: selectedProduct
        })

    };
    updateLeftUnit = (event) => {
        this.setState({leftUnit: event.target.value})
    }
    updateMeasure = (event) => {
        this.setState({measure: event.target.value})
    }
    updateRightUnit = (event) => {
        this.setState({rightUnit: event.target.value})
    }
    updateProduct = (value) => {
        this.setState({
            product: value,
            suggestions: this.state.category == category[0] ? this.state.standardProgramProtection[value] : this.state.standardProgramNutritional[value]
        })
    }
    updateCategory = (event) => {
        this.setState({category: event.target.value},()=>{
            this.updateProduct(this.state.product)
        })
    }

    render() {


        // const classes = useStyles();

        return (

            <DocumentTitle title="Khula - Favorite farmers">
                <div className="main-content">
                    {!isDashboard() && <div>

                        <div className="col-sm-12 col-xs-12 col-lg-12 col-md-12">
                            {/*// <Search style={{*/}
                            {/*//     marginTop: "1%"*/}
                            {/*// }}/>*/}
                            <label>{this.props.location.state.farmerProfile.name + " " + this.props.location.state.farmerProfile.surname}</label>
                            <br/>
                            Product<select onChange={event => {this.updateProduct(event.target.value)} }value={this.state.product}>
                            {products.map((unit, i) =>
                                <option value={unit}>{unit}</option>
                            )}
                        </select><span/>
                            Category
                            <select onChange={this.updateCategory} value={this.state.category}>
                                {category.map((unit, i) =>
                                    <option value={unit}>{unit}</option>
                                )}
                            </select>
                            <br/>
                            <br/>
                            <AutoComplete
                                hintText="Search Product"
                                style={{
                                    paddingTop: "-0.3%"
                                }}
                                searchText={this.state.searchText}
                                onUpdateInput={this.handleUpdateInput}
                                onNewRequest={this.handleNewRequest}
                                dataSource={this.state.datasource}
                            />
                            {/*<MuiPickersUtilsProvider utils={DateFnsUtils}>*/}
                            <TextField
                                margin="normal"
                                label="Date picker"
                                value={this.state.selectedDate}
                                onChange={this.handleDateChange}
                            />
                            {/*</MuiPickersUtilsProvider>*/}
                            <TextField
                                id="outlined-adornment-amount"
                                variant="outlined"
                                label="Rate"
                                value={this.state.amount}
                                onChange={(e) => this.setState({
                                    amount: e.target.value
                                })}

                            />

                            <select onChange={this.updateLeftUnit} value={this.state.leftUnit}>
                                {leftUnits.map((unit, i) =>
                                    <option value={unit}>{unit}</option>
                                )}
                            </select>/
                            <select onChange={this.updateRightUnit} value={this.state.rightUnit}>
                                {rightUnits.map((unit, i) =>
                                    <option value={unit}>{unit}</option>
                                )}
                            </select>

                            <TextField
                                id="outlined-adornment-amount"
                                variant="outlined"
                                label="Application"
                                value={this.state.application}
                                onChange={(e) => this.setState({
                                    application: e.target.value
                                })}

                            />
                            <select onChange={this.updateMeasure} value={this.state.measure}>
                                {aplicationUnits.map((unit, i) =>
                                    <option value={unit}>{unit}</option>
                                )}
                            </select>
                            <TextField
                                id="outlined-adornment-amount"
                                variant="outlined"
                                label="PHI"
                                value={this.state.phi}
                                onChange={(e) => this.setState({
                                    phi: e.target.value
                                })}

                            />
                            <TextField
                                id="outlined-adornment-amount"
                                variant="outlined"
                                label="Target"
                                value={this.state.bbugs}
                                onChange={(e) => this.setState({
                                    bugs: e.target.value
                                })}

                            />
                            <TextField
                                id="outlined-adornment-amount"
                                variant="outlined"
                                label="Active ingredient"
                                value={this.state.ingredient}
                                onChange={(e) => this.setState({
                                    ingredient: e.target.value
                                })}

                            />
                            <TextField
                                id="outlined-adornment-amount"
                                variant="outlined"
                                label="Comments"
                                value={this.state.comments}
                                onChange={(e) => this.setState({
                                    comments: e.target.value
                                })}

                            />
                            <button onClick={() => this.addToSuggestedList()} style={styles.marginSide}
                                    className="uk-button uk-button-primary" type="button">Add to program
                            </button>
                            <button onClick={() => this.uploadSuggestion()} style={styles.marginSide}
                                    className="uk-button uk-button-primary" type="button">Upload Suggestion
                            </button>

                            <table className="uk-table uk-table-middle uk-table-divider">
                                <thead>
                                <tr>
                                    <th className="uk-width-small">Suggested Date</th>
                                    <th>Product Name</th>
                                    <th>UOM</th>
                                    <th>Quantity to apply</th>
                                    <th>PHI</th>
                                    <th>Price</th>
                                    <th>Dilution</th>
                                    <th>Application</th>
                                    <th>Target</th>
                                    <th>Active ingredient</th>
                                    <th>Comments</th>
                                    <th>Actions</th>
                                    {/*<th>Produce Name</th>*/}
                                    {/*<th>Description</th>*/}
                                    {/*<th>Price (per Unit)</th>*/}
                                </tr>
                                </thead>
                                <tbody>
                                {
                                    this.state.suggestions.map((suggestion, i) =>
                                        <tr key={i}>
                                            <td>
                                                {suggestion.selectedDate}
                                            </td>
                                            <td>{suggestion.selectedProduct.name}</td>
                                            <td>{suggestion.selectedProduct.measurement}</td>
                                            <td>{suggestion.quantity}</td>
                                            <td>{suggestion.PHI}</td>
                                            <td>{suggestion.selectedProduct.price}</td>
                                            <td>{suggestion.rate}</td>
                                            <td>{suggestion.application}</td>
                                            <td>{suggestion.bugs}</td>
                                            <td>{suggestion.ingredient}</td>
                                            <td>{suggestion.comment}</td>
                                            <button onClick={() => this.handleRemove(suggestion)}>Delete</button>
                                            {/*<Replay/>*/}
                                            {/*<td>R {order.clientPrice} </td>*/}
                                        </tr>
                                    )
                                }
                                </tbody>

                            </table>
                        </div>
                    </div>
                    }
                </div>
            </DocumentTitle>
        );
    }


}


export default AddSprayingProgram;



// WEBPACK FOOTER //
// ./src/pages/HomePageBabies/AddSprayingProgram.js